import { BeDeskbar, BeMenu, BeMenuItem, BeMenuSeparator, BeRow } from "@beos-css/react/index.ts";

import icon3dmix from "../../icons/3dmix.png";
import iconBeide from "../../icons/beide.png";
import iconBurner from "../../icons/burner.png";
import iconFolder from "../../icons/folder.png";
import iconPeople from "../../icons/people.png";
import iconQuickres from "../../icons/quickres.png";
import iconSoftwareValet from "../../icons/software-valet.png";
import iconSoundRecorder from "../../icons/soundrecorder.png";
import iconStyledEdit from "../../icons/stylededit.png";
import iconTerminal from "../../icons/terminal.png";

function TraySpeaker() {
	return (
		<svg className="be-deskbar__tray-icon" viewBox="0 0 15 15" aria-label="Volume" role="img">
			<path fill="#000" d="M2 6h2l3-2.5v8L4 9H2V6Z" />
			<path fill="none" stroke="#000" strokeWidth="1" d="M9 5.5c1 .8 1 3.2 0 4M10.5 4c1.8 1.4 1.8 5.6 0 7" />
		</svg>
	);
}

export function DeskbarDemo() {
	return (
		<section id="demo-deskbar">
			<h2>Deskbar (Be menu + Status View + app list)</h2>
			<p>
				The three R5 Deskbar sections: the dotted dragger grip, a replicant tray, and the app list with real extracted mini icons. The clock
				ticks live, and the Be logo toggles the menu — shown open here. Its folder entries are Tracker's <code>ModelMenuItem</code>, which
				blits a <code>B_MINI_ICON</code> beside the label and stands a row taller than a plain item.
			</p>
			<BeRow wrap gap="row">
				<BeDeskbar
					defaultMenuOpen
					location="left-top"
					tray={<TraySpeaker />}
					apps={[
						{ name: "People", icon: iconPeople },
						{ name: "Terminal", icon: iconTerminal },
						{ name: "BeIDE", icon: iconBeide },
						{ name: "SoftwareValet", icon: iconSoftwareValet },
						{ name: "SoundRecorder", icon: iconSoundRecorder },
						{ name: "QuickRes", icon: iconQuickres },
						{ name: "Burner", icon: iconBurner },
						{ name: "3dmiX", icon: icon3dmix },
						{ name: "StyledEdit", icon: iconStyledEdit },
						/* The colour fallback for an app with no icon -- a whole branch of
						 * BeDeskbar that had no demo coverage, so nothing rendered it. */
						{ name: "NoIcon", color: "#6698cb" },
					]}
					menu={
						<BeMenu aria-label="Be">
							<BeMenuItem onSelect={() => {}}>About BeOS…</BeMenuItem>
							<BeMenuSeparator />
							<BeMenuItem shortcut={{ key: "F" }} onSelect={() => {}}>
								Find…
							</BeMenuItem>
							<BeMenuItem onSelect={() => {}}>Show Replicants</BeMenuItem>
							<BeMenuItem onSelect={() => {}}>Configure Be Menu…</BeMenuItem>
							<BeMenuSeparator />
							{/* the folder entries are Tracker ModelMenuItems: a mini icon and a caret */}
							<BeMenuItem icon={<img src={iconFolder} alt="" />} submenu onSelect={() => {}}>
								Applications
							</BeMenuItem>
							<BeMenuItem icon={<img src={iconFolder} alt="" />} submenu onSelect={() => {}}>
								Preferences
							</BeMenuItem>
							<BeMenuItem icon={<img src={iconFolder} alt="" />} submenu disabled>
								Demos
							</BeMenuItem>
							<BeMenuSeparator />
							<BeMenuItem onSelect={() => {}}>Restart</BeMenuItem>
							<BeMenuItem onSelect={() => {}}>Shut Down…</BeMenuItem>
						</BeMenu>
					}
				/>
			</BeRow>
		</section>
	);
}
